import { Configuration, PublicClientApplication } from "@azure/msal-browser";

const msalConfig: Configuration = {
  auth: {
    clientId: "3127bcca-da9b-4985-b1ef-a9d451a0b7de",
    authority: "https://login.microsoftonline.com/common",
    redirectUri: window.location.origin + "/account/login",
  },
  cache: {
    cacheLocation: "sessionStorage",
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const loginRequest = {
  scopes: ["openid", "profile", "email"],
};
